import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const OpenIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 23.5 23.5",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 23.5),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m8.17 22.5h-7.17v-7.17m14.33-14.33h7.17v7.17"
    }), /*#__PURE__*/jsx("path", {
      d: "m22.5 15.33v7.17h-7.17"
    }), /*#__PURE__*/jsx("path", {
      d: "m1 8.17v-7.17h7.17"
    })]
  });
};

export { OpenIcon };
//# sourceMappingURL=open.js.map
